import type { GridColDef, GridRowIdGetter } from '@mui/x-data-grid-premium';
import {
    FromApplicationStatus,
    PerformedBy,
    ToApplicationStatus
} from '../columns';
import type { OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges } from '../types';

export const useOnboardingDataGrid = () => {
    const columns: GridColDef[] = [
        {
            field: 'applicationId',
            headerName: 'Application ID',
            width: 150,
            align: 'center',
            headerAlign: 'center',
            sortable: true,
            filterable: false
        },
        {
            field: 'resource',
            headerName: 'Affected Section',
            width: 500,
            hide: true,
            filterable: false
        },
        {
            field: 'updatedByUserId',
            headerName: 'Performed By',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            filterable: false,
            renderCell: params => (
                <PerformedBy
                    {...params}
                />
            )
        },
        {
            field: 'updatedDateTime',
            headerName: 'Timestamp',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            filterable: false
        },
        {
            field: 'hCreatedDateTime',
            headerName: 'From Status',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            filterable: false,
            renderCell: params => (
                <FromApplicationStatus
                    {...params}
                />
            )
        },
        {
            field: 'touchedBy',
            headerName: 'To Status',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            filterable: false,
            renderCell: params => (
                <ToApplicationStatus
                    {...params}
                />
            )
        }
    ];

    const getRowId: GridRowIdGetter<OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges> = ({ coreId }) => coreId;

    return {
        columns,
        getRowId
    };
};
